import React from 'react';

// Client-side pagination helper mirroring the pattern used across the
// Remote Diagnostics session tables (6 page buttons window + << / >> jumps).
// Returns the current page slice plus a renderer for the page-number controls,
// so new screens don't re-inline the same logic.
//
// Usage:
//   const { pageItems, totalPages, renderPageNumbers } =
//     usePagination(filteredRows, currentPage, setCurrentPage, rowsPerPage);
export default function usePagination(items, currentPage, setCurrentPage, rowsPerPage = 10) {
  const list = Array.isArray(items) ? items : [];
  const totalPages = Math.max(1, Math.ceil(list.length / rowsPerPage));

  const pageItems = list.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  const handlePageChange = (pageNumber) => {
    const clamped = Math.min(Math.max(1, pageNumber), totalPages);
    setCurrentPage(clamped);
  };

  const renderPageNumbers = () => {
    if (totalPages <= 1) return null;

    const maxPagesToShow = 6;
    let startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2));
    let endPage = startPage + maxPagesToShow - 1;

    if (endPage > totalPages) {
      endPage = totalPages;
      startPage = Math.max(1, endPage - maxPagesToShow + 1);
    }

    const pageNumbers = [];
    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <button
          key={i}
          onClick={() => handlePageChange(i)}
          className={currentPage === i ? 'active' : ''}
        >
          {i}
        </button>
      );
    }

    return (
      <>
        <button onClick={() => handlePageChange(1)}>{'<<'}</button>
        {pageNumbers}
        <button onClick={() => handlePageChange(totalPages)}>{'>>'}</button>
      </>
    );
  };

  return { pageItems, totalPages, handlePageChange, renderPageNumbers };
}
